var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgCompletion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clipboard-check",
    d: "M16,2h-.171A3.006,3.006,0,0,0,13,0H11A3.006,3.006,0,0,0,8.171,2H8A5.006,5.006,0,0,0,3,7V19a5.006,5.006,0,0,0,5,5h8a5.006,5.006,0,0,0,5-5V7A5.006,5.006,0,0,0,16,2Zm.707,9.579-3.562,3.562a2.924,2.924,0,0,1-4.052.089L7.325,13.609a1,1,0,0,1,1.351-1.475l1.768,1.621a.93.93,0,0,0,1.287-.028l3.562-3.562a1,1,0,0,1,1.414,1.414Z",
    transform: "translate(-3)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgCompletion);
export default __webpack_public_path__ + "static/media/avg-completion.5e439b39bc4e0f6ff8febf1e14f1c650.svg";
export { ForwardRef as ReactComponent };